module.exports = __webpack_public_path__ + "img/sankaku_69_blue.6aed100c.png";